import $ from 'jquery';

/**
 * The group-contact form (contacts/contact-groups.antlers.html, fields from
 * resources/blueprints/forms/group_contact.yaml — so the input names below are
 * field handles, not markup you will find in a template): the two date range
 * pickers, the "svuota" reset button and the extra field revealed once the
 * message textarea has content.
 */
export function initContactGroupsForm() {
    const pickers = initDateRangePickers();

    $('.svuota').click(function () {
        const form = $('form')[0];
        if (form) form.reset();

        $('select').each(function () {
            $(this).val($(this).find('option:eq(0)').val());
            $(this).trigger('change');
        });
    });

    $('.trigger-field textarea').on('input change', function () {
        if ($(this).val().trim() !== '') {
            $('.inputgroup')
                .closest('.d-none')
                .removeClass('d-none');
        } else {
            $('.inputgroup')
                .closest('.col-12')
                .addClass('d-none');
        }
    });

    return pickers;
}

/**
 * `daterange1` and `daterange2` are the desired and the alternative period of a
 * group enquiry. They are the only reason this project has daterangepicker, and
 * the only reason it has moment (daterangepicker requires it) — together 99 KB
 * that used to sit in every page's bundle for two fields of one form on one
 * page. They come as a chunk now, fetched when those two inputs are present.
 */
function initDateRangePickers() {
    const inputs = ['daterange1', 'daterange2']
        .map((name) => $('input[name="' + name + '"]'))
        .filter((input) => input.length > 0);

    if (!inputs.length) {
        return null;
    }

    return import('../lib/dateRangePicker').then(({ moment }) => {
        inputs.forEach((input) => {
            input.daterangepicker({
                ranges: true,
                autoApply: true,
                applyButtonClasses: false,
                autoUpdateInput: true,
                opens: 'left',
                minDate: moment(),
                startDate: moment(),
                endDate: moment().add(7, 'days'),
                locale: {
                    format: 'DD/MM/YYYY',
                },
            }, function (start) {
                input.val(start.format('DD/MM/YYYY'));
            });
        });
    });
}
